import { useContext } from 'react';
import { I18nContext } from '@/context/i18nContext';

/**
 * Diccionario e idioma activos.
 *
 * No lanza si falta el proveedor —devuelve español— por las razones escritas
 * en `i18nContext.ts`.
 */
export function useI18n() {
  return useContext(I18nContext);
}
